import { ReportsSource } from 'modules/arena/reports/source/types';

// Usada fora do modo de demonstração enquanto a integração de relatórios não existe.
// Não chama nenhuma URL: apenas informa que a fonte não está conectada. Nunca devolve
// números fictícios como fallback.
const NOT_CONNECTED = 'A integração de relatórios ainda não está conectada a este ambiente.';

export function createNotConnectedSource(arenaKey: string): ReportsSource {
  const fail = () => Promise.reject(new Error(NOT_CONNECTED));
  return {
    id: `not-connected:${arenaKey}`,
    capabilities: {
      minDate: '2000-01-01',
      maxRangeDays: 366,
      compare: false,
      grouping: false,
      export: { csv: false, pdf: false, expiresInMinutes: null },
      demo: false,
    },
    loadContext: async () => ({ status: 'not_connected', message: NOT_CONNECTED }),
    fetchArea: async () => ({ status: 'not_connected', meta: null, message: NOT_CONNECTED, body: null }),
    fetchTable: fail,
    fetchDetail: fail,
    exportArea: async () => ({ status: 'error', message: NOT_CONNECTED }),
  };
}
